<body>

   <div class="wrapper">
      <header>
         <nav>
            <a href="home">
               <div class="mobile-logo">
                  GaniSponsor Market
               </div>
            </a>

            <div class="menu-icon">
               <i class="fa fa-bars fa-2x" (click)="onMenuClick()"></i>
            </div>

            <div class="menu">
               <ul class="left" [hidden]="isPropertyOwner">
                  <li>
                     <a href="home">
                        <div class="logo">
                           <span class="logo-fulltext">GaniSponsor Market</span>
                           <span class="logo-shorttext">Market</span>
                        </div>
                     </a>
                  </li>

                  <!-- <li>
                     <a>
                        <div class="separator">
                        </div>
                     </a>
                  </li>

                  <li [(visible)]="displayLogin">
                     <a [routerLink]="['/home']"><span class="full-text">Properties</span>
                        <span class="short-text">Property</span>
                     </a>
                  </li> -->

                  <!-- <li>
                     <a>
                        <div class="separator">
                        </div>
                     </a>
                  </li> -->

                  <!-- <li>
                     <a [routerLink]="['/sponsors']"><span class="full-text">Sponsors</span>
                        <span class="short-text">Sponsors</span>
                     </a>
                  </li> -->
<!-- 
                  <li>
                     <a>
                        <div class="separator">
                        </div>
                     </a>
                  </li> -->

                  <li [hidden]="isHidden">
                     <a [routerLink]="['/reg-page']"><span class="full-text">Register your Property</span>
                        <span class="short-text">Register</span>
                     </a>
                  </li>

                  <!-- <li><button class="btn btn-success" (click)="signOutOfSocialProvider()">Signout SP</button></li>  -->

                  

                  <!-- <li>
                     <a>
                       <div class="separator">
                       </div>
                     </a>
                    </li>

                    <li [hidden]="isHidden">
                     <a (click)="signOut()">Log Out</a>
                    </li> -->
                  <!-- <li>
                        <a [routerLink]="['/reg-page']">Sign Up</a>
                    </li> -->
               </ul>

               <ul class="left" [hidden]="!isPropertyOwner">
                  <li>
                     <a href="home">
                        <div class="logo">
                           <span class="logo-fulltext">GaniSponsor Market</span>
                           <span class="logo-shorttext">Market</span>
                        </div>
                     </a>
                  </li>
                  <!-- <li>
                     <a>
                        <div class="separator">
                        </div>
                     </a>
                  </li> -->
                  <!-- <li class="nav-item dropdown">
                     <a class="dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="full-text">Applications</span>
                        <span class="short-text">Applications</span>
                     </a>
                     <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                     <a style="display: block;" class="header-link">Sponsorships</a>
                     <a style="display: block;" class="header-link"  (click)="gotoValuations()">Valuations</a>
                     </div>
                  </li> -->
                  <!-- <li>
                     <a>
                        <div class="separator">
                        </div>
                     </a>
                  </li>

                  <li [(visible)]="displayLogin">
                     <a [routerLink]="['/home']"><span class="full-text">Properties</span>
                        <span class="short-text">Property</span>
                     </a>
                  </li> -->

                  <!-- <li>
                     <a>
                        <div class="separator">
                        </div>
                     </a>
                  </li>

                  <li>
                     <a [routerLink]="['/sponsors']"><span class="full-text">Sponsors</span>
                        <span class="short-text">Sponsors</span>
                     </a>
                  </li> -->

                  <!-- <li>
                     <a>
                        <div class="separator">
                        </div>
                     </a>
                  </li>

                  <li>
                     <a [routerLink]="['/sponsors']"><span class="full-text">Sponsorships</span>
                        <span class="short-text">Sponsorships</span>
                     </a>
                  </li> -->
                  <!-- <li>
                     <a>
                        <div class="separator">
                        </div>
                     </a>
                  </li> -->

               </ul>

               <ul class="pull-right signin" *ngIf="pageName">
                  <li [hidden]="!isHidden">
                     <a>
                        <div class="dropdown">
                           <button class="signOut" (click)="showSignInDropdown(); $event.stopPropagation()">
                              <a class="dropdown-toggle" id="signInDropdown" role="button">
                                 Sign In </a>
                           </button>
                           <div class="dropdown-menu  dropdown-menu-right show shadow rounded" [@scaleIn]
                              *ngIf="signInMenu" aria-labelledby="signInDropdown">
                              <div class="col-12 nogutters">
                                 <a class="header-link pointer" (click)="onDisplayLogin()">Property Owner</a>
                              </div>
                              <!-- <hr class="nogutters">
                              <div class="col-12 nogutters">
                                 <a class="header-link pointer" (click)="sponsorLogin()">Sponsor</a>
                              </div> -->

                              <!-- <div class="col-12 nogutters">
                                 <button class="btn btn-primary" (click) = "signInWithGoogle()">Sign in with Google</button>
                              </div>

                              <div class="col-12 nogutters">
                                 <button class="btn btn-primary" (click) = "signInWithFB()">Sign in with FaceBook</button>
                              </div> -->
                           </div> 
                        </div>
                     </a>

                     <!-- <a class="pointer" (click)="onDisplayLogin()">Sign In</a> -->
                  </li>

                  <li [hidden]="!isHidden">
                     <a>
                        <div class="separator s_signIn">
                        </div>
                     </a>
                  </li>

                  <li class="m-r-1 sign_up_btn" [hidden]="!isHidden">
                     <a>
                        <button type="button" (click)="onDisplaySignUp()"
                           class="btn btn-lg btn-teal rounded-pill shadow lift lift-sm">Sign Up</button>
                     </a>
                  </li>

                  <li [hidden]="isHidden" class="avatar">
                     <a>
                        <img src="../../../../assets/images/profile_avatar_tranparent.png" class="user-img" alt="user">
                     </a>
                     <a>
                        <div class="row m-r-1">
                           <button class="signOut" (click)="showDropdown(); $event.stopPropagation()">
                              <a class="dropdown-toggle" id="navbarDropdown" role="button">
                                 {{ username }} </a>
                           </button>
                           <div class="dropdown-menu show dropdown-menu-right shadow rounded" [@scaleIn] 
                              *ngIf="userMenu" aria-labelledby="navbarDropdown">
                              
                              <!-- <div class="col-12" *ngIf="userGroup === 'properties'">
                                 <a (click)="gotoValuations()" class="header-link">My Valuations</a>
                              </div> -->
                              <!-- <div class="col-12" *ngIf="userGroup === 'sponsors'">
                                 <a (click)="gotoValuations()" class="header-link">Valuations</a>
                              </div>
                              <div class="col-12" *ngIf="userGroup === 'sponsors'">
                                 <a (click)="gotoEvaluations()" class="header-link">Applications</a>
                              </div> -->
                              <!-- <div class="col-12" *ngIf="userGroup === 'properties'">
                                 <a (click)="goToOwnerEvaluations()" class="header-link">My Applications</a>
                              </div> -->
                              <div class="col-12" *ngIf="userGroup === 'properties'">
                                 <a (click)="goToPrivateSpace()" class="header-link">My Private Space</a>
                              </div>
                              <hr class="nogutters">
                              <div class="col-12">
                                 <a class="logout-link" (click)="signOut()">Log Out</a>
                              </div>
                           </div>
                        </div>
                     </a>
                  </li>
               </ul>
            </div>

         </nav>
      </header>

   </div>
</body>

<app-navigation-modal [(visible)]="showMenu"></app-navigation-modal>

<app-signin [(visible)]="displayReg" (closeLogin)="close($event)"></app-signin>
<app-login [(visible)]="displayLogin" (closeLogin)="close($event)"></app-login>
<!-- <app-sponsors-login [(visible)]="displaySponsor"></app-sponsors-login> -->